import {Component, ChangeDetectionStrategy} from "@angular/core";
import {PerformaInfoService} from "src/app/services/performa-info.service";

@Component({
    selector: "app-error-500",
    templateUrl: "./error500.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Error500Component {
    constructor(public readonly infoService: PerformaInfoService) {}
}
